import { render, staticRenderFns } from "./SupportContent.vue?vue&type=template&id=1ae59123&scoped=true&"
import script from "./SupportContent.vue?vue&type=script&lang=js&"
export * from "./SupportContent.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/all.css?vue&type=style&index=0&id=1ae59123&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae59123",
  null
  
)

export default component.exports